import { render, staticRenderFns } from "./EditEventCategoryPage.vue?vue&type=template&id=4cb63a11&"
import script from "./EditEventCategoryPage.vue?vue&type=script&lang=js&"
export * from "./EditEventCategoryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports